import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { SITE } from '@/content/site';

const ease = [0.16, 1, 0.3, 1];

export default function ParentStudioCTA() {
  return (
    <section className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.95, ease }}
          className="relative rounded-[1.75rem] border border-[hsl(var(--hairline))] bg-[hsl(var(--cream-2))]/60 p-10 lg:p-14 grain overflow-hidden"
        >
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-end relative z-10">
            <div className="lg:col-span-7">
              <div className="text-overline mb-6">More Than Lashes</div>
              <h2 className="font-display text-[1.75rem] sm:text-3xl lg:text-[2.5rem] leading-[1.15] max-w-2xl">
                Looking for more than a lash lift?
                <span className="italic text-[hsl(var(--primary))] font-medium"> Visit our full-service studio.</span>
              </h2>
              <p className="mt-6 max-w-xl text-[hsl(var(--muted-foreground))] leading-[1.8]">
                Lash Lift Vancouver is the lash-focused face of <span className="italic">Prép Beauty Parlour</span> —
                Downtown Vancouver&apos;s award-winning salon for hair, balayage, brows, nails and skin
                on Burrard Street. Same studio, same artists, full menu of services.
              </p>
            </div>
            <div className="lg:col-span-5 flex lg:justify-end">
              <div className="flex flex-wrap items-center gap-4">
                <a
                  data-testid="parent-studio-cta"
                  href={SITE.parentSite}
                  target="_blank"
                  rel="noopener"
                  className="btn-luxe inline-flex items-center gap-2.5 rounded-full bg-[hsl(var(--warm-ink))] text-[hsl(var(--cream))] px-9 py-4 text-[0.72rem] tracking-[0.24em] uppercase font-light hover:bg-[hsl(var(--primary))] transition-colors duration-700 group"
                >
                  Visit prepbeautyparlour.com
                  <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.25} />
                </a>
                <a
                  data-testid="parent-studio-services"
                  href={`${SITE.parentSite}/services`}
                  target="_blank"
                  rel="noopener"
                  className="inline-flex items-center gap-1.5 text-[0.72rem] tracking-[0.24em] uppercase font-light text-[hsl(var(--primary))] hover:gap-3 transition-all duration-500"
                >
                  Full service menu <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.25} />
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-[hsl(var(--hairline))] grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-4 text-[0.62rem] uppercase tracking-[0.32em] text-[hsl(var(--muted-foreground))] font-light relative z-10">
            <span>Hair · Cut & Colour</span>
            <span>Balayage Vancouver</span>
            <span>Brow Lamination</span>
            <span>Manicure & Pedicure</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
